import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowRight, Star } from 'lucide-react';
import { Hero } from '../components/Hero';
import { FeaturedServices } from '../components/FeaturedServices';
import { SpecialsStrip } from '../components/SpecialsStrip';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { SectionHeading } from '../components/SectionHeading';
import { Gallery } from '../components/Gallery';
import { Reviews } from '../components/Reviews';
import { ServiceAreas } from '../components/ServiceAreas';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';

/** Old one-page anchors now live on their own pages. */
const legacyAnchors: Record<string, string> = {
  services: '/services',
  packages: '/services',
  extras: '/services',
  'service-details': '/services',
  about: '/about',
  gallery: '/gallery',
  reviews: '/reviews',
  faq: '/faq',
  contact: '/contact',
  'contact-form': '/contact'
};
export function HomePage() {
  const {
    hash
  } = useLocation();
  const navigate = useNavigate();
  usePageMeta({
    title: "Mike's Pro Detail | Mobile Car Detailing in Ventura County",
    description: "Mike's Pro Detail provides professional mobile car detailing throughout Ventura County and select surrounding areas. We come to you for convenient interior, exterior and full car detailing. Call or text 818-381-9905.",
    path: '/'
  });
  useEffect(() => {
    const target = legacyAnchors[hash.slice(1)];
    if (target) navigate(target, {
      replace: true
    });
  }, [hash, navigate]);
  return <main data-id="element-1063" data-mp="20pe06krxp42e">
      <Hero data-id="element-1064" data-mp="20ss5o1vw9te2" />
      <FeaturedServices data-id="element-1065" data-mp="20t1s5fhqdif0" />
      <SpecialsStrip data-id="element-1066" data-mp="25qbjj0ook45h" />
      <WhyChooseUs data-id="element-1067" data-mp="25ql8qm1wi7a4" />

      <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" data-id="element-1068" data-mp="25r3dk72mpttn">
        <div className="max-w-6xl mx-auto" data-id="element-1069" data-mp="3c52p3hor0d5u">
          <SectionHeading title="Our Work" subtitle="Real before-and-after results from customers in Ventura County." data-id="element-1070" data-mp="3h4ysbepmg0kc" />
          <Gallery limit={4} data-id="element-1071" data-mp="2rga5rvjdfg7b" />
          <div className="mt-10 text-center" data-id="element-1072" data-mp="2rfi88f67r8ee">
            <Link to="/gallery" className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/80 text-white hover:bg-white hover:text-black font-black uppercase tracking-wider rounded-sm transition-colors duration-150" data-id="element-1073" data-mp="2mhqjtv4s24ey">
              View Gallery
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-1074" data-mp="2wgfrkv2ym8hh" />
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" data-id="element-1075" data-mp="28nz7keznw6fj">
        <div className="max-w-7xl mx-auto" data-id="element-1076" data-mp="23t1zpbe4c348">
          <SectionHeading title="5-Star Mobile Detailing Reviews" subtitle={<span className="inline-flex items-center gap-2" data-id="element-1078" data-mp="2ii7ywzcyhtc4">
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" aria-hidden="true" data-id="element-1079" data-mp="2domxexc5mh86" />
                5.0 average rating across Google &amp; Yelp
              </span>} data-id="element-1077" data-mp="2ign376ewo4co" />
          <Reviews limit={3} data-id="element-1080" data-mp="1l195jdnbcbux" />
          <div className="mt-10 text-center" data-id="element-1081" data-mp="1l07wtftrs1gd">
            <Link to="/reviews" className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/80 text-white hover:bg-white hover:text-black font-black uppercase tracking-wider rounded-sm transition-colors duration-150" data-id="element-1082" data-mp="iovlv8y8amh">
              Read More Reviews
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-1083" data-mp="3mrq5a670epnc" />
            </Link>
          </div>
        </div>
      </section>

      <ServiceAreas data-id="element-1084" data-mp="j96n5wi1p069" />
      <CallCta data-id="element-1085" data-mp="j8og04tuh1jk" />
    </main>;
}